import { useState } from 'react';
import emailjs from 'emailjs-com';
import React from 'react';
import Header from '../header/header';
import Footer from '../footer/footer';
import ReviewsSlider from './carrousselavis';

const initialState = {
  user_name: "",
  user_email: "",
  user_phone: "",
  message: "",
};

const Contact = (props) => {
const [{ user_name, user_email, user_phone, message }, setState] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({ ...prevState, [name]: value }));
  };

  const clearState = () => setState({ ...initialState });

  const handleSubmit = (e) => {
    e.preventDefault();

     if (!user_name || !user_email || !user_phone || !message) {
    alert("Merci de remplir tous les champs.");
    return;
  }
  
    setLoading(true);
    setSuccess(false);

    emailjs
      .sendForm(
        "service_oscjfaq",
        "template_xnou9oi",
        e.target,
        "-n4N1s9lNARVExiaV"
      )
      .then(
        (result) => {
          console.log(result.text);
          clearState();
          setSuccess(true);
        },
        (error) => {
          console.log(error.text);
        }
      )
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      <Header />

      <div id="activites">
        <div className="container">

          <div className="col-md-6">
            <div className="row">
              <div className="section-title">
                <br></br><br></br>
                <h2>Contact</h2>

        <div className="activites-list">
<br></br><br></br><br></br>
  <h3>Pour la fleuristerie sur mesure & création florale personnalisée :</h3>

  <p>
    Les commandes se font <strong>uniquement sur rendez-vous</strong>, en <strong>click & collect</strong> pour vous garantir un service personnalisé et de qualité.
  </p>
<br></br>
  <h4>Horaires de click & collect :</h4>

  <br></br>
    <ul className='libouquets'>
  <li><strong>Lundi :</strong> 17h - 19h</li>
  <li><strong>Mardi :</strong> 17h - 19h</li>
  <li><strong>Mercredi :</strong> 17h - 19h</li>
  <li><strong>Jeudi :</strong> 17h - 19h</li>
  <li><strong>Vendredi :</strong> 17h - 19h</li>
  <li><strong>Samedi :</strong> 9h30 - 19h</li>
  <li><strong>Dimanche :</strong> 9h30 - 15h</li>

  </ul>
<br></br><br></br>

  <h3>Pour les événements & les projets paysagers :</h3>




                <section className="zones-intervention">
                    <p>
    Contactez-moi pour discuter de votre projet et obtenir un accompagnement sur mesure.
  </p>
                  <p>
                    J’interviens principalement à <strong>Paris</strong> et dans toute l’<strong>Île-de-France</strong> (91, 92, 93, 94, 95, 77, 78, 60).
                  </p>

                  <p>
                    Des interventions sont possibles dans d’autres départements en France sur demande, avec prise en charge des frais de déplacement.
                  </p>
                </section>

                <p>
                  Remplissez le formulaire ci-dessous pour obtenir un devis personnalisé ou simplement poser vos questions. Une réponse vous est garantie sous 48 heures.
                </p>
            </div>
</div>
              <form name="sentMessage" onSubmit={handleSubmit} noValidate>
                <div className="row">
                  <div className="col-md-3">
                    <div className="form-group">
                      <input
                        type="text"
                        name="user_name"
                        className="form-control"
                        placeholder="Nom"
                        required
                        value={user_name}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

     <div className="col-md-3">
                    <div className="form-group">
                      <input
                       type="tel"
                        name="user_phone"
                        className="form-control"
                        placeholder="Téléphone"
                        value={user_phone}
                         onChange={handleChange}
                         required
                        
                      />
                    </div>
                  </div>

<div className="col-md-6">
                    <div className="form-group">
                      <input
                        type="email"
                        name="user_email"
                        className="form-control"
                        placeholder="Email"
                        required
                        value={user_email}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>

<div className="col-md-12">
                <div className="form-group">
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Message"
                    required
                    value={message}
                    onChange={handleChange}
                  ></textarea>
                </div></div>
                {success && (
                  <div id="success">
                    <p style={{ color: "green", marginTop: "10px" }}>
                      ✅ Merci ! Votre message a bien été envoyé.
                    </p>
                  </div>
                )}


                <button
                  type="submit"
                  className="btn btn-custom btn-lg"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="sendform">Envoi en cours...</span>
                  ) : (
                    <span className="sendform">Envoyer un message !</span>
                  )}
                </button>
              </form>
 <div className="section-title">

        <div className="activites-list">
          <br></br>
      <h3>  Vos retours ( d’après{" "}
 <a href="https://www.mariages.net/fleurs-mariage/delphia-paul--e351539" target="_blank" rel="noopener noreferrer">
    Mariages.net – Delphia PAUL ) :
  </a>
    </h3>
             <ReviewsSlider /></div></div>
       </div>
            </div>

       

<div id='contact'>
          <div className="container">

          <div className="col-md-3 col-md-offset-1 contact-info">
            <div className="contact-item">
              <h3>Informations pratiques :</h3>
              <p>
                <span>
                  <i className="fa fa-map-marker"></i> Localisation
                </span>
                21 Rue Aristide Briand, Chennevières sur Marne, 94430
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-phone"></i> Téléphone
                </span>
                +33 6 25 00 67 53
              </p>
            </div>

            <div className="contact-item">
              <p>
                <span>
                  <i className="fa fa-envelope-o"></i> Email
                </span>
                contact.jdp@delphiapaul.fr
              </p>
            </div>
             <div className="social">
                <ul>
                  <li>
                    <a href="https://www.instagram.com/delphiajpaul/" target="_blank" rel="noreferrer">
                      <i className="fa fa-instagram"></i>
                    </a>
                  </li>

                  <li>
                    <a
                      href="https://wa.me/33625006753"
                      target="_blank"
                      rel="noreferrer"
                    >
                      <i className="fa fa-whatsapp"></i>
                    </a>
                  </li>

                </ul>
</div>
              </div>
          </div>
        
             
        </div>
      </div>
</div>
      <Footer />
    </div>
  );
};

export default Contact;